module.exports = __webpack_public_path__ + "img/78f8aecabaa9cdc9abfe7761c18487be.78f8aeca.png";